export default {
  backgroundColor: 'rgba(251,215,96,.21)',
  color: 'var(--black)',
  fontSize: '0.8rem',
  padding: '0.5rem 0',
  mobileTextAlign: 'center',
  borderRadius: '4px',
};
